import { CampaignsState, ImportData, ImportStep } from './types/types'

export const initialState: CampaignsState = {
	importStep: ImportStep.CREATE_CAMPAIGN,
	importData: {} as ImportData,
}
